import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';

/**
 * Generated class for the TareaDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tarea-detalle',
  templateUrl: 'tarea-detalle.html',
})
export class TareaDetallePage {
  item = {id : null, Nombre : null};
  tareas = [{id:null,Nombre : null}];

  constructor(public navCtrl: NavController, public navParams: NavParams,public alertCtrl: AlertController,public partesService : PartesService) {
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }

    //Cargo las Cuadrillas
    partesService.getTareas()
    .subscribe(tareas => {
      this.tareas = tareas;
  });    
  }
  //Añadir Tarea
  addTarea(){
    this.partesService.addTarea(this.item);
    this.navCtrl.pop();
  } 

  //Borrar Tarea
  deleteTarea(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar esta Tarea?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteTarea(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  } 

  ionViewDidLoad() {
    console.log('ionViewDidLoad TareaDetallePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/tarea-detalle/tarea-detalle.ts